<!-- Back to Top -->
<div class="scrollToTop" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <a (click)="scrollToTop()" class="back-to-top">
    <i class="fa fa-chevron-up"></i>
  </a>
</div>
